// extracted by mini-css-extract-plugin
module.exports = {"Container":"QuickCard_Container__8ONoa","Avatar":"QuickCard_Avatar__3DNXH","OpLabel":"QuickCard_OpLabel__ds7Gz","PrintingNote":"QuickCard_PrintingNote__2PdV5"};